import React, { useState } from 'react';

function SurveyStepTwo({ formData, onNext }) {
    const [rating, setRating] = useState(formData.rating || '');
    const [comments, setComments] = useState(formData.comments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!rating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ rating, comments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 1: Compliance & Training</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How well do you understand and follow our Standard Operating Procedures (SOPs)? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`rating-${option}`}
                            name="rating"
                            value={option}
                            checked={rating === option}
                            onChange={() => setRating(option)}
                        />
                        <label htmlFor={`rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    placeholder="Share any thoughts or suggestions..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!rating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwo;
